export default {
  BACKSPACE: 8,
  DOWN: 40,
  ENTER: 13,
  ESCAPE: 27,
  K: 75,
  LEFT: 37,
  RIGHT: 39,
  TAB: 9,
  DEC_0: 48,
  DEC_9: 57,
  UP: 38,
  DOT: 190,
  NUMPAD_DECIMAL: 110,
};
